<template>
  <a-form ref="formRef" :model="formState" :rules="rules" layout="vertical">
    <div class="separator"></div>
    <div class="separator"></div>
    <a-row :gutter="24">
      <a-col :span="12">
        <a-form-item label="Nombres" name="first_name">
          <a-input v-model:value="formState.first_name" placeholder="Escribir nombres" />
        </a-form-item>
      </a-col>
      <a-col :span="12">
        <a-form-item label="Apellidos" name="last_name">
          <a-input v-model:value="formState.last_name" placeholder="Escribir apellido" />
        </a-form-item>
      </a-col>
    </a-row>
    <div class="separator"></div>
    <a-form-item label="Teléfono de contacto" name="phone" :required="!$route.query.generatedUser">
      <a-row :gutter="24" type="flex">
        <a-col :span="7">
          <selector-country :code="code_phone" @selected="code_phone = $event" />
        </a-col>
        <a-col :span="17">
          <a-input v-model:value="formState.phone" placeholder="Número de teléfono" />
        </a-col>
      </a-row>
    </a-form-item>
    <div class="separator"></div>
    <div class="continue__register">
      <a-row>
        <a-col :span="24">
          <a-button
            class="continue"
            type="primary"
            html-type="submit"
            @click="handleSubmit"
            :disabled="formState.first_name === ''"
          >
            Continuar
          </a-button>
        </a-col>
      </a-row>
    </div>
  </a-form>
</template>

<script>
import { defineComponent, reactive, ref, toRaw, computed, watch } from "vue";
import { useStore } from "vuex";
import SelectorCountry from "@/app/shared/components/selectors/SelectorCountry.vue";

export default defineComponent({
  props: {
    countryId: {
      type: Number,
      required: true,
    },
  },
  components: {
    SelectorCountry,
  },
  setup(props) {
    const formRef = ref();
    const store = useStore();
    const getInformationUser = computed(() => store.getters["getNewUser"]);
    const code_phone = ref(props.countryId ?? (getInformationUser.value?.code_phone || 1));
    watch(
      () => props.countryId,
      (newValue) => {
        code_phone.value = newValue;
      }
    );
    const formState = reactive({
      first_name: getInformationUser.value?.first_name,
      last_name: getInformationUser.value?.last_name,
      phone: getInformationUser.value?.phone,
    });
    const rules = {
      first_name: [
        {
          required: true,
          message: "Campo requerido",
          trigger: "change",
        },
      ],
      last_name: [
        {
          required: true,
          message: "Campo requerido",
          trigger: "blur",
        },
      ],
      // phone: [
      //   {
      //     required: !route.query.generatedUser,
      //     message: "Teléfono inválido",
      //     type: "number",
      //   },
      // ],
    };

    return {
      rules,
      formState,
      formRef,
      store,
      code_phone,
      getInformationUser,
    };
  },

  computed: {
    countries() {
      return this.store.getters["getAllCountries"];
    },
  },
  methods: {
    handleSubmit() {
      this.formRef
        .validateFields()
        .then(() => {
          this.handleSubmitForm(toRaw(this.formState));
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    handleSubmitForm(data) {
      this.$store.dispatch("addPropertiesToNewUser", {
        ...data,
        code_phone: this.code_phone,
      });
      this.$store.dispatch("setRegisterStep", 2);
    },
  },
});
</script>

<style lang="sass" scoped>
.ant-form
  position: relative

  &-item
    margin-bottom: 16px

.item
  &__checkbox
    margin-bottom: 0

.flag
  width: 20px
  margin-bottom: 2px
  margin-right: 4px

.separator
  margin-bottom: 20px

.login
  text-align: center

.continue
  width: 100%

.continue__register
  margin: 60px 0 30px
</style>
